import { useEffect, useState } from "react";
import { Cake, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, waLink } from "@/lib/api";

const MONTHS = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

export function Birthdays({ store }) {
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/customers/birthdays", { params: { month } }).then((r) => setList(r.data)); }, [month]);
  const msg = (c) => `Olá, ${c.name.split(" ")[0]}! 🎉 A equipe ${store} deseja um feliz aniversário, com muita saúde e alegria. Esperamos você para comemorar com a gente!`;
  return (
    <div className="card-surface" data-testid="birthdays-card">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b p-4">
        <p className="eyebrow flex items-center gap-2"><Cake className="h-4 w-4 text-primary" />Aniversariantes de {MONTHS[month - 1]}</p>
        <select value={month} onChange={(e) => setMonth(Number(e.target.value))} className="h-9 rounded-md border bg-transparent px-2 text-sm" data-testid="birthdays-month-select">
          {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
        </select>
      </div>
      <ul className="divide-y text-sm" data-testid="birthdays-list">
        {list.map((c) => {
          const day = Number(c.birth_date.slice(8, 10));
          const today = month === now.getMonth() + 1 && day === now.getDate();
          const phone = c.whatsapp || c.phone;
          return (
            <li key={c.id} className="flex flex-wrap items-center gap-3 p-4" data-testid={`birthday-row-${c.id}`}>
              <span className={`grid h-10 w-10 place-items-center rounded-lg font-mono font-bold ${today ? "bg-primary text-primary-foreground" : "bg-muted"}`}>{String(day).padStart(2, "0")}</span>
              <span className="flex-1 min-w-[140px] font-medium">{c.name}{today && <span className="ml-2 text-xs text-primary">hoje!</span>}</span>
              {phone ? (
                <Button asChild size="sm" variant="outline" data-testid={`birthday-whatsapp-${c.id}`}>
                  <a href={waLink(phone, msg(c))} target="_blank" rel="noreferrer"><MessageCircle className="h-4 w-4 mr-1 text-emerald-500" />Enviar parabéns</a>
                </Button>
              ) : <span className="text-xs text-muted-foreground">sem WhatsApp</span>}
            </li>
          );
        })}
        {!list.length && <li className="p-4 text-muted-foreground">Nenhum aniversariante neste mês.</li>}
      </ul>
    </div>
  );
}
